<template>
    <div class="dashboard--wrapper">
            <div class="graph-group">
                <div v-if="title" class="graph-group--info">
                    <div class="graph-group--info--text--1">
                        <span>{{ title }}</span>
                        <span v-if="adminDescription"> - {{ adminDescription }} </span>
                        <a v-if="canAddResident || canChangeDescription" @click.prevent="updateDescription" href="#" class="graph-group--info--add-description">(upravit)</a>
                    </div>
<!--                    TODO: pokud je img, tak classa "graph-group--info--img--show"-->
                    <div v-if="displayResident" class="graph-group--info--text--2">
<!--                        <span>{{ $t('graphGroup.resident') }} </span>-->
                        <img src="images/img-byt-1.png" alt="" class="graph-group--info--img" width="32">
                        <a href="#" v-if="resident">{{ resident.user.lastName }} {{ resident.user.firstName }}</a>
                        <span v-if="!resident">Nevyplněno</span>
                    </div>
                </div>
                <div class="graph-group--graph" v-bind:class="{'graph-group--full-width': devices.length === 1}">
                    <div v-for="item in devices" v-bind:key="'device' + item.id">
                        <consuption-graph v-bind="item"></consuption-graph>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
  import ConsuptionGraph from "@/components/Widgets/ConsuptionGraph";
  export default {
    name: "GraphGroup",
    components: { ConsuptionGraph },
    props: {
        id: Number,
        title: String,
        adminDescription: String,
        displayResident: Boolean,
        devices: Array,
        resident: Object,
        canAddResident: Boolean,
        canChangeDescription: Boolean
    },
    data: function(){
      return {
      };
    },
    methods: {
      updateDescription: function(){
        this.$emit('open-popup', {
          name: 'update-structure',
          structureId: this.id,
        });
      },
      updateGraphs: function(){
        for (let i = 0; i < this.$children.length; i++) {
          if(this.$children.hasOwnProperty(i) && this.$children[i].updateData){
            this.$children[i].updateData()
          }
        }
      }
    }
  }
</script>

<style scoped lang="less">
    .graph-group {
        &--info {
            display: flex;
            align-items: center;
            padding: 0 0 25px;
            &--text {
                &--1 {
                    font-size: 24px;
                    font-weight: 500;
                    color: #2A0F51;
                }
                &--2 {
                    font-size: 14px;
                    font-weight: 400;
                    color: #2A0F51;
                    background: rgba(8, 62, 137, 0.08);
                    border-radius: 100px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 32px;
                    padding: 5px 18px;
                    margin-left: 14px;
                    position: relative;
                    a {
                        color: currentColor;
                        display: block;
                        text-decoration: none;
                    }
                }
            }
            &--img {
                position: absolute;
                top: 0;
                left: 0;
                display: none;
                &--show {
                    padding-left: 43px;
                    .graph-group--info--img {
                        display: block;
                    }
                }
            }
            &--add-description{
                font-size: 0.813rem;
                color: #b2b3b7;
                font-weight: 400;
                &:hover{
                    color: #2a0f51;
                }
            }
        }
        @media only screen and (min-width: 1024px) {
            &--graph {
                display: flex;
                margin: -10px;
                > div {
                    width: 50%;
                    padding: 10px;
                    display: flex;
                }
            }
        }
        &--full-width{
            display: flex;
            margin: -10px;
            > div {
                width: 100%;
                padding: 10px;
            }
        }
    }
</style>
